import { useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { Controller, useForm } from 'react-hook-form';
import Sidebar from '../../components/Sidebar/Sidebar';
import Header from '../../components/Header/Header';
import CategoryModal from '../../components/Shared/Modals/CategoryModal';
import CategoryTable from '../../components/Table/CategoryTable/CategoryTable';
import { setSubCategory } from '../../slices/new-syllabusSlice';
import { useDispatch } from 'react-redux';
import { addSubCategory, deleteSubCategory, updateSubCategory } from '../../services/operations/new-syllabus';

const AllSubCategory = () => {
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const { AllSubCategories, AllCategories, SubCategory } = useSelector((state) => state.new_syllabus);
    const [modalOpen, setModalOpen] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const dispatch = useDispatch();

    const {
        handleSubmit,
        control,
        setValue,
        formState: { errors, isSubmitted },
        reset,
    } = useForm({
        defaultValues: {},
    });
    const formattedAllcategories = useMemo(() => AllCategories.map((sub) => {
        return [...sub.categories];
    }).flat(), [AllCategories]);

    const handleAddProblem = (e) => {
        e.stopPropagation();
        reset({
            name: '',
            slug: '',
            category_id: '',
            rank: '',
            type: 'normal',
        });
        setIsEdit(false);
        setModalOpen(true);
    };

    const handleSubCatEdit = (e, subCatData) => {
        e.stopPropagation();
        console.log(subCatData);

        const { id ,name, slug, cat_id, rank, type } = subCatData;

        const data = {
            id,
            name,
            slug,
            category_id:cat_id,
            rank,
            type,
        };

        dispatch(setSubCategory(data));
        reset(data);
        setIsEdit(true);
        setModalOpen(true);
    };
    const { isProd } = useSelector((state) => state.auth);

    const handleDeleteSubCat= (subcat_slug,setDeleteModalOpen) => {
       
        dispatch(deleteSubCategory(subcat_slug, isProd));
        setDeleteModalOpen(false)

    
    }

    const onSubmit = (data) => {
        
        const { name, slug, category_id, rank, type } = data;

        if (isEdit) {
            const { id } = SubCategory;
            dispatch(updateSubCategory(id, name, slug, category_id, rank, type, setModalOpen, isProd));
        } else {
            dispatch(addSubCategory(name, slug, category_id, rank, type, setModalOpen, isProd));
        }
    };


    return (
        <div className='flex dark:bg-dark font-primary  h-screen overflow-hidden bg-[#fafafa]'>
            <Sidebar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
            <div className='relative flex flex-col flex-1 overflow-y-auto overflow-x-hidden'>
                <Header sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
                <main>
                    <div className='px-4 mb-8 sm:px-6 lg:px-8 w-full max-w-9xl mx-auto'>
                        <div className='flex justify-between items-center px-6 py-4'>
                            <h2 className='text-2xl font-bold text-[#212121] dark:text-zinc-200'>
                                All SubCategory
                            </h2>
                        </div>
                        <div className='flex justify-between items-center px-6 py-4'>
                            <button
                                onClick={handleAddProblem}
                                className='bg-[#FFD3B5] dark:bg-zinc-800 text-[#212121] dark:text-zinc-200 font-semibold py-2 px-4 rounded-lg'
                            >
                                Add SubCategory
                            </button>
                        </div>

                        <div className='flex gap-y-2 flex-col justify-start'>
                            {AllSubCategories.length > 0 ? (
                                <div className='flex flex-col p-4 '>
                                    <CategoryTable
                                        page='New_Subcategory'
                                        setIsEdit={setIsEdit}
                                        topics={AllSubCategories}
                                        setModalOpen={setModalOpen}
                                        modalOpen={modalOpen}
                                        handleEdit={handleSubCatEdit}
                                        handleDelete={handleDeleteSubCat}
                                    />
                                </div>
                            ) : (
                                <div className='flex justify-center items-center text-4xl dark:text-zinc-300'>
                                    No Sub Category to show
                                </div>
                            )}
                        </div>
                        <CategoryModal
                            title='Add sub category'
                            setModalOpen={setModalOpen}
                            modalOpen={modalOpen}
                        >
                            <form className='mt-6' onSubmit={handleSubmit(onSubmit)}>
                                <div className='flex flex-col flex-wrap -mx-3 mb-4'>
                                    <span className='px-3 text-lg font-semibold text-light_30 mb-2 dark:text-zinc-300'>
                                        Name
                                    </span>
                                    <div className='w-full px-3'>
                                        <Controller
                                            name='name'
                                            control={control}
                                            render={({ field }) => (
                                                <input
                                                    id='name'
                                                    type='text'
                                                    name='name'
                                                    className='form-input w-full text-gray-300'
                                                    placeholder='name'
                                                    onChange={(e) => {
                                                        field.onChange(e);
                                                        const filteredValue = e.target.value
                                                            .toLowerCase()
                                                            .replace(/[\s/]/g, '-');
                                                        setValue('slug', filteredValue);
                                                    }}
                                                    value={field.value}
                                                />
                                            )}
                                            rules={{
                                                required: 'Name is required',
                                            }}
                                        />
                                        {isSubmitted && errors.name && (
                                            <p className='text-red-600 text-sm italic'>
                                                {errors.name.message}
                                            </p>
                                        )}
                                    </div>
                                </div>

                                <div className='flex flex-col flex-wrap -mx-3 mb-4'>
                                    <span className='px-3 text-lg font-semibold text-light_30 mb-2 dark:text-zinc-300'>
                                        Slug
                                    </span>
                                    <div className='w-full px-3'>
                                        <Controller
                                            name='slug'
                                            control={control}
                                            render={({ field }) => (
                                                <input
                                                    id='slug'
                                                    type='text'
                                                    name='slug'
                                                    className='form-input w-full text-gray-300'
                                                    placeholder='slug'
                                                    {...field}
                                                />
                                            )}
                                            rules={{
                                                validate: (value) => {
                                                    const validSlugRegex = /^[a-zA-Z0-9_-]+$/;
                                                    if (!validSlugRegex.test(value)) {
                                                        return 'Slug can only contain letters, numbers, underscores, and hyphens';
                                                    }
                                                    return true;
                                                },
                                            }}
                                        />
                                        {isSubmitted && errors.slug && (
                                            <p className='text-red-600 text-sm italic'>
                                                {errors.slug.message}
                                            </p>
                                        )}
                                    </div>
                                </div>
                                <div className='flex flex-col flex-wrap -mx-3 mb-4'>
                                    <span className='px-3 text-lg font-semibold text-light_30 mb-2 dark:text-zinc-300'>
                                        Category
                                    </span>
                                    <div className='w-full px-3'>
                                        <Controller
                                            name='category_id'
                                            control={control}
                                            render={({ field }) => (
                                                <select {...field} className='bg-zinc-900 rounded-md w-full'>
                                                   {formattedAllcategories.map((cat) => (
                                                        <option key={cat.id} value={cat.id}>{cat.name}</option>
                                                    ))}
                                                </select>
                                            )}
                                            rules={{
                                                required: 'category is required',
                                            }}
                                        />
                                        {isSubmitted && errors.slug && (
                                            <p className='text-red-600 text-sm italic'>
                                                {errors.slug.message}
                                            </p>
                                        )}
                                    </div>
                                </div>
                                <div className='flex flex-col flex-wrap -mx-3 mb-4'>
                                    <span className='px-3 text-lg font-semibold text-light_30 mb-2 dark:text-zinc-300'>
                                        Rank
                                    </span>
                                    <div className='w-full px-3'>
                                        <Controller
                                            name='rank'
                                            control={control}
                                            render={({ field }) => (
                                                <input
                                                    id='rank'
                                                    type='text'
                                                    name='rank'
                                                    className='form-input w-full text-gray-300'
                                                    placeholder='rank'
                                                    {...field}
                                                />
                                            )}
                                            rules={{
                                                required: 'Rank is required',
                                            }}
                                        />
                                        {isSubmitted && errors.slug && (
                                            <p className='text-red-600 text-sm italic'>
                                                {errors.slug.message}
                                            </p>
                                        )}
                                    </div>
                                </div>
                                <div className='flex flex-col flex-wrap -mx-3 mb-4'>
                                    <span className='px-3 text-lg font-semibold text-light_30 mb-2 dark:text-zinc-300'>
                                        Type
                                    </span>
                                    <div className='w-full px-3'>
                                        <Controller
                                            name='type'
                                            control={control}
                                            render={({ field }) => (
                                                <select
                                                    {...field}
                                                    className='bg-zinc-900 rounded-md w-full'
                                                >
                                                    <option value='normal'>normal</option>
                                                    <option value='contest'>contest</option>
                                                </select>
                                            )}
                                            rules={{
                                                required: 'type is required',
                                            }}
                                        />
                                        {isSubmitted && errors.slug && (
                                            <p className='text-red-600 text-sm italic'>
                                                {errors?.type?.message}
                                            </p>
                                        )}
                                    </div>
                                </div>

                                <div className='flex flex-wrap -mx-3 mt-6'>
                                    <div className='w-full px-3'>
                                        <button type='submit' className='btn-brand-2 w-full'>
                                            Submit
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </CategoryModal>
                    </div>
                </main>
            </div>
        </div>
    );
};

export default AllSubCategory;
